<script>
import { Field, Button } from "vant";
import popupMultiple from "@/components/popupMultiple";

export default {
  name: "formMultiple",
  components: {
    [Field.name]: Field,
    [Button.name]: Button,
    popupMultiple,
  },
  props: {
    search: {
      type: Boolean,
      default: false,
    },
    searchFilter: {
      type: [String, Array, Function],
      default: () => ["text", "simpleCode"],
    },
    searchPlaceholder: {
      type: String,
      default: "",
    },
    value: {
      type: Array,
      default: () => [],
    },
    label: {
      type: String,
      default: "",
    },
    columns: {
      type: Array,
      default: () => [],
    },
    placeholder: {
      type: String,
      default: "请选择",
    },
    required: {
      type: Boolean,
      default: false,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    keyField: {
      type: String,
      default: "Id",
    },
    textField: {
      type: String,
      default: "Text",
    },
    popupTextField: {
      type: String,
      default: "",
    },
    checkedField: {
      type: String,
      default: "isChecked",
    },
    fieldButtonType: {
      type: String,
      default: "primary",
    },
    isConfirm: {
      type: Boolean,
      default: false,
    },
    confirmButtonText: {
      type: String,
      default: "确认",
    },
    cancelButtonText: {
      type: String,
      default: "清空",
    },
    max: {
      type: [String, Number],
      default: null,
    },
    maxRequired: {
      type: String,
      default: "最大选择数量:",
    },
    maxHeight: {
      type: String,
      default: "60vh",
    },
    closeOnClickOverlay: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      // copyValue: [],
      copyColumns: [],
      visible: false,
    };
  },
  watch: {},
  created() {},
  methods: {
    popupShow() {
      let { readonly, columns } = this;
      if (!readonly && columns.length) {
        this.visible = true;
      }
      this.$emit("click");
    },
    confirm(value, valueList) {
      this.$emit("input", value, valueList);
      this.$emit("change", value, valueList);
      this.$emit("submit", value, valueList);
    },
    cancel() {
      this.visible = false;
      this.valueUpdate([]);
    },
    fieldRender() {
      const btns = this.buttonRender();
      let arrow;
      if (!this.readonly) {
        arrow = <i class="van-icon van-icon-arrow" />;
      }
      let titleCls = "van-cell__title van-field__label";
      if (this.required) {
        titleCls = "van-cell__title van-field__label required";
      }
      return (
        <div class="van-cell van-field" onClick={this.popupShow}>
          <div class={titleCls}>
            <span>{this.label}</span>
          </div>
          <div class="van-cell__value van-field__value">
            <div class="van-field__body">{btns}</div>
            <div class="van-field__right-icon">{arrow}</div>
          </div>
        </div>
      );
    },
    buttonRender() {
      let { value, keyField, textField, fieldButtonType } = this;
      let btns = [];
      this.columns.map(p => {
        if (value && value.includes(p[keyField])) {
          btns.push(
            <van-button size="mini" class="btn" type={fieldButtonType}>
              {p[textField]}
            </van-button>,
          );
        }
      });
      return btns;
    },
    popupMultipleRender() {
      const {
        value,
        columns,
        keyField,
        textField,
        popupTextField,
        isConfirm,
        cancelButtonText,
        confirmButtonText,
        confirm,
        visible,
        max,
        maxHeight,
        search,
        searchFilter,
        searchPlaceholder,
      } = this;
      const option = {
        props: {
          keys: value,
          visible,
          columns,
          keyField,
          textField: popupTextField ? popupTextField : textField,
          isConfirm,
          cancelButtonText,
          confirmButtonText,
          max,
          maxHeight,
          closeOnClickOverlay: this.closeOnClickOverlay,
          search,
          searchFilter,
          searchPlaceholder,
        },
        on: {
          input: val => {
            this.visible = val;
          },
          "update:keys": val => {
            this.$emit("input", val);
          },
          change: val => {
            this.$emit("change", val);
            this.submit(val);
          },
          confirm: confirm,
        },
      };
      return <popupMultiple {...option} />;
    },
  },
  render() {
    return (
      <div>
        {this.fieldRender()}
        <div />
        {this.popupMultipleRender()}
      </div>
    );
  },
};
</script>

<style lang="less" scoped>
/deep/.van-cell__value {
  text-align: left;
  line-height: initial;
  display: flex;
  .van-field__body {
    display: inline-block;
    flex: 1;
    .btn {
      padding: 0 4px;
      margin: 3px 4px 3px 0;
      float: left;
      height: 18px;
      line-height: 18px;
    }
    .van-field__right-icon {
      line-height: 24px;
    }
  }
}

/deep/.van-field__right-icon {
  line-height: 24px;
}

.item {
  position: relative;
  padding-right: 40px;
  .icon-success {
    position: absolute;
    right: 15px;
    top: 13px;
    color: green;
    font-size: 20px;
  }
}
/deep/.van-cell__title.required::before {
  position: absolute;
  left: 0.21333rem;
  color: #ee0a24;
  font-size: 0.37333rem;
  content: "*";
}
</style>
